<!-- <div class="d-flex h-100 flex-column table-wrapper">
  < class="d-flex justify-content-end align-items-center px-2">
    <div class="col d-flex gap-2 py-2" *ngIf="displayHeader">
      <app-search-input class="col-3" [searchValue]="searchText" (changeSearchTextValue)="searchFilter($event)"></app-search-input>
      <div *ngIf="isSubscriptionListHeader" class="col d-flex m-0 p-0 gap-2">
        
        
        <app-dropdown *ngIf="isShowStatusDropdown" [selectedValue]="statusValue" [options]="statusList" [dropdownLabel]="'Status'" (valueChanged)="changeStatusValue.emit=$event" class="col-1 status-button"></app-dropdown>
        
        <app-dropdown *ngIf="isShowPlanDropdown" [selectedValue]="plansValue" [options]="getAllDropdownData?.plansDropdown" [dropdownLabel]="'Plan'" (valueChanged)="changePlansValue.emit = $event" class="col-2"></app-dropdown>
        <app-dropdown [options]="dateRangeList" [dropdownLabel]="'Date Range'" [id]="'dateRange'" (dropdownValueEmit)="range($event)" class="col-2"></app-dropdown>
        <ng-container *ngIf="this.isCustomRange==4">
          <app-date-picker></app-date-picker>
          <div class="text-center my-auto">
            <svg class="rotate-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="20" viewBox="0 0 11.071 7.745">
              <path id="Union_68" data-name="Union 68" d="M3.372,0V9.157L.707,6.492,0,7.2l3.873,3.873L7.745,7.2l-.707-.707L4.372,9.157V0Z" fill="#383838"/>
            </svg>
          </div>
          <app-date-picker></app-date-picker>
        </ng-container>
        
      </div>
      <div *ngIf="isFilter">
        <app-button [customClass]="'default'" [buttonLabel]="'Filter'" [svgName]="'filter'"></app-button>
      </div>
    </div> -->
    <!-- <div class="py-1" *ngIf="isAmountList">
      <div class="f-12 font-medium d-flex">
        <div class="text-dark-black2-color w-50 text-end">Amt</div>
        :
        <div class="text-red ms-1">20000.00</div>
      </div>
      <div class="f-12 font-medium d-flex">
        <div class="text-dark-black2-color w-50 text-end">Paid</div>
        :
        <div class="text-red ms-1">10000.00</div>
      </div>
      <div class="f-12 font-medium d-flex">
        <div class="text-dark-black2-color w-50 text-end">Balance</div>
        :
        <div class="text-red ms-1">10000.00</div>
      </div>
    </div> -->
  <div class="flex-fill h-0">
    <ag-grid-angular
      #{{tableId}}
      class="ag-theme-alpine w-100 h-100"
      [defaultColDef]="
        tableRowCellEditable ? defaultColDef : defaultColDefination
      "
      [columnDefs]="dataModel?.colDefs"
      [rowData]="rowData"
      [headerHeight]="28"
      [rowHeight]="30"
      [animateRows]="true"
      [suppressRowClickSelection]="true"
      [suppressDragLeaveHidesColumns]="true"
      [rowSelection]="rowSelection"
      (selectionChanged)="onSelectionChanged($event)"
      (cellKeyDown)="onCellKeyDown($event)"
      [components]="components"
      (gridReady)="onGridReady($event)"
      (movingChanged)="onMovingChanged($event)"
      (rowClicked)="onRowClicked($event)"
      [enableCellEditingOnBackspace]="true"
      (dragStopped)="onDrag($event)"
      [pagination]="pagination"
      [paginationPageSize]="25"
      (cellClicked)="onCellClicked($event)"
      (cellValueChanged)="onCellValueChanged($event)"
       (cellEditingStopped)="onCellEditingStopped($event)"
      [stopEditingWhenCellsLoseFocus]="true"
      stopEditingWhenGridLosesFocus="true"
      [autoGroupColumnDef]="autoGroupColumnDef"
      [getRowStyle]="getRowStyle"
      [gridOptions]="gridOptions"
      [getRowClass]="getRowClass"
      [rowDragMultiRow]="true"
      [rowDragManaged]="true"
      (customButtonClick)="handleCustomButtonClick($event)"
      (customHeaderEvent)="handleCustomHeaderEvent($event)"
      (checkBoxClick)="handleCheckBoxClick($event)"
      (previewIconClick)="handlePreviewIconClick($event)"
      (sendButtonClick)="handleSendIconClick($event)"
      (StatusButtonClick)="handleStatusButtonClick($event)"
      (onSaveExtendSubscription)="handleSaveExtendSubsButtonClick($event)"
      (editCreditButtonClick)="handleEditCreditButtonClick($event)"
      (refreshButtonClick)="handleRefreshButtonClick($event)"
      (cellContextMenu)="handleCellContextMenu($event)"
      >
    </ag-grid-angular>
  </div>
  <div class="col-12 p-2 pagination_div" *ngIf="dataModel?.showPagination">
    <div class="d-flex justify-content-between align-items-center pagination-wrapper">
      <div class="text-nowrap text-gray-color font-regular f-11 ps-1 pagination-info">
         Showing <span class="font-semibold">{{totalRecords === 0 ? '0' : getStartRange()}}</span>
         to <span class="font-semibold">{{getEndRange() || '0'}}</span> 
         of <span class="font-semibold">{{totalRecords || '0'}}</span> entries
      </div> 
      <div class="page-size-control px-2 d-flex justify-content-end gap-2">
        <div class="align-content-center">
          <select [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange()"
            class="page-size-dropdown f-11 border-white cursorPointer pe-2">
            <option *ngFor="let option of pageLimitOptions" [value]="option.value">
              {{ option.value === 1 ? 'Show All Items' : 'Show ' + option.value + ' Items' }}
            </option>
          </select>
        </div>
        <div class="d-flex pagination-control responsive-btn  min-w-btn">
          <ngb-pagination #ngbPage [boundaryLinks]="false" [collectionSize]="pageSize === 1 ? 1 :totalRecords"
            [pageSize]="pagination.pageSize" [page]="pagination.page" [maxSize]="5"
            (pageChange)="onPageNumberChanged($event)">
            <ng-template ngbPaginationPrevious>Previous</ng-template>
            <ng-template ngbPaginationNext>Next</ng-template>
          </ngb-pagination>
        </div>
      </div>
    </div>
  </div>
<!-- </div> -->
